import { useState } from "react";
import { Button, Form, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useNavigate } from "react-router-dom";
import {
  SendOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import api from "../../services/nysService";

import {
  fieldValidity,
  Messages,
  Notify,
  openNotification,
  util
} from "@seims/shared";

import { recordError } from "../../utils/logService";

const RejectCandidate = ({
  candidate,
  setCurrentStatus,
  intake,
  setVisible,
  userId,
  open,
  currentStatus,
}) => {
  let navigate = useNavigate();

  const [disabled, setDisabled] = useState(true);
  const [pageTitle, setPageTitle] = useState("Rejection Reason");
  const [modalStatus, setModalStatus] = useState("");

  const [feedBack, setFeedBack] = useState(true);
  const [feedBackNotes, setFeedBackNotes] = useState(true);
  const [value, setValue] = useState();
  const [ValidStatus, setValidStatus] = useState(fieldValidity.SUCCESS);
  const [ValidNotesStatus, setValidNotesStatus] = useState(
    fieldValidity.SUCCESS
  );
  const [ValidityMsg, setValidityMsg] = useState("");
  const [ValidityNotesMsg, setValidityNotesMsg] = useState("");

  const formName = "RejectCandidateForm";
  const [form] = Form.useForm();

  const onSubmit = async (values) => {
    var msg;
    var action = "Reject candidate";

    try {
      const response = await api.rejectCandidate(userId, intake, values.reason);

      if (response && response?.status == 200) {
        msg = util.parseMessage(Messages.REJECTION_SUCCESS, action);
        openNotification(action, msg, Notify.SUCCESS);
        setVisible(false);

        const { data } = response;
        // setModalStatus(data.value);

        // if (candidate) {
        // }
        const { key } = candidate?.selectedStatus;
        form.resetFields();
        navigate("/candidate/status/" + key);

        return;
      }

      msg = util.parseMessage(Messages.REJECTION_FAILED, action);
      openNotification(action, msg, Notify.ERROR);
    } catch (error) {
      if (error.response.status == 409) {
        msg = util.parseMessage(Messages.REJECTION_EXISTS, action);
        openNotification(action, msg, Notify.ERROR);
        recordError(error);
        return;
      }

      msg = util.parseMessage(Messages.REJECTION_FAILED, action);
      openNotification(action, msg, Notify.ERROR);
      return;
    }
    //?Adding candidate, status, datetime
  };

  // const Confirm = () => {
  //   form.resetFields();
  //   onShow(false);
  //   setDisabled(true);
  //   setCurrentStatus(modalStatus);
  // };

  // const handleFeedbackChange = (value) => {
  //   setValue(value);
  //   form.setFieldsValue({ notes: value });
  //   setValidityNotesMsg("");
  // };

  const handleCancel = () => {
    form.resetFields();
    setVisible(false);
    setDisabled(false);
    setCurrentStatus(modalStatus);
  };

  return (
    <Modal
      title={pageTitle}
      open={open}
      closable={false}
      keyboard={false}
      maskClosable={false}
      key="RejectCandidate"
      footer={[
        <div className="modal-footer-buttons">
          <Button
            type="primary"
            htmlType="submit"
            // onSubmit={createUser}
            form={formName}
            key="save"
          >
            <SendOutlined />
            Save
          </Button>
          <Button
            onMouseUp={() => handleCancel()}
            style={{ marginLeft: 10 }}
            type="danger"
            key="cancel"
          >
            <CloseCircleOutlined />
            Cancel
          </Button>
        </div>,
      ]}
    >
      <>
        <div style={{ width: "100%", paddingBottom: 20 }} key="reject-msg">
          <h3>Please provide a reason for the Rejection</h3>
        </div>
        <Form
          name={formName}
          form={form}
          layout="horizontal"
          onFinish={onSubmit}
          key="form"
        >
          <Form.Item
            name="reason"
            label="Reason"
            validateStatus={ValidNotesStatus}
            help={ValidityNotesMsg}
            rules={[
              {
                required: feedBackNotes,
                message: ValidityNotesMsg,
              },
            ]}
          >
            <TextArea rows={3} />
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default RejectCandidate;
